import React from "react";
import Input from "../components/Input";
import Select from "../components/Select";
import Textarea from "../components/Textarea";
import Button from "../components/Button";
import Typography from "../../Typography";
import Testimonials from "../components/Testimonials";

export default function BookMeeting() {
  return (
    <div className="bg-black">
      <div className="wrapper max-xl:!max-w-[100%] max-md:px-0">
        <div className=" max-md:flex-col flex flex-row gap-[15px] justify-between relative overflow-hidden">
          <div className="max-md:hidden absolute top-0 left-0 right-0 h-[150px] z-[1] black-t1"></div>
          <div className="max-md:hidden absolute bottom-0 left-0 right-0 h-[150px] z-[1] black-t2"></div>
          <div className="max-md:pb-[30px] max-md:px-[15px] max-md:max-w-[100%] max-lg:max-w-[calc(100%-360px)] max-xl:max-w-[calc(100%-480px)] max-2xl:max-w-[500px] max-w-[650px] max-xsm:py-[50px] max-md:py-[70px] py-[100px]">
            <Typography.Subt className="text-white">
              Make an appointment
            </Typography.Subt>
            <Typography.P className="text-white max-w-[870px] mt-[20px] opacity-80">
              The best way to enjoy a treatment in our studio is to make an
              appointment with the desired artist. Fill out the form below and
              we will contact you to discuss your appointment.
            </Typography.P>
            <form>
              <div className="flex gap-[20px] flex-wrap max-md:mt-[30px] mt-[50px]">
                <label className="max-2xl:w-full w-[calc(50%-10px)]">
                  <Input placeholder="Name and surname" required="required" />
                </label>
                <label className="max-2xl:w-full w-[calc(50%-10px)]">
                  <Input type="email" placeholder="Email" required="required" />
                </label>
                <label className="max-2xl:w-full w-[calc(50%-10px)]">
                  <Input placeholder="Phone Number" required="required" />
                </label>
                <label className="max-2xl:w-full w-[calc(50%-10px)]">
                  <Select
                    placeholder="Body part"
                    iconRight="./imgs/icons/arrow-white.svg"
                    required="required"
                    options={[
                      { value: "option1", label: "Option 1" },
                      { value: "option2", label: "Option 2" },
                      { value: "option3", label: "Option 3" },
                    ]}
                  />
                </label>
                <label className="max-2xl:w-full w-[calc(50%-10px)]">
                  <Select
                    placeholder="Tattoo color"
                    iconRight="./imgs/icons/arrow-white.svg"
                    required="required"
                    options={[
                      { value: "option1", label: "Option 1" },
                      { value: "option2", label: "Option 2" },
                      { value: "option3", label: "Option 3" },
                    ]}
                  />
                </label>
                <label className="max-2xl:w-full w-[calc(50%-10px)]">
                  <Input
                    placeholder="Tattoo size (e.g. 20x30)"
                    required="required"
                  />
                </label>
                <label className="w-full">
                  <Textarea placeholder="Your message" required />
                </label>
                <Button variant="secondary">Make an appointment</Button>
              </div>
            </form>
          </div>
          <div className="max-md:pb-[10px] max-md:max-w-[100%] max-md:flex-col max-md:relative max-lg:max-w-[350px] max-2xl:max-w-[450px] w-full flex flex-grow overflow-hidden max-w-[500px] absolute right-[0]">
            <Testimonials />
          </div>
        </div>
      </div>
    </div>
  );
}
